import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'business-small',
  footer: 'business-small',
}

const pageBrand: PageBrand = 'corporate'

export const smallBusiness = new LineOfBusinessConfig(geConfig, pageBrand)
